export default "__VITE_ASSET__D_k2BEcY__"